<template>
	<uiModal title="Gerar código para chat mútiplos"
		icon="fal fa-code"
		name="marketing-queues-multiple-chat-code"
		size="lg">
		<div class="modal">
			<form class="modal-content">
				<div class="subtitle">1 - Informe o Título do menu:</div>
				<ui-input type="text" v-model="title" placeholder="Ex: Selecione o departamento" />

				<div class="subtitle">2 - Selecione as Filas para o menu do chat:</div>

				<ui-queues-table v-model="code" :title="title" />
			</form>
			<div v-if="code" class="modal-aside">
				<div class="title">Cole o código abaixo em seu site dentro da tag <strong>Head</strong>.</div>
				<ui-overlay-load v-if="loaderCode" color="#2d93f8" :size="60" :stroke="8" />
				<ui-code :copy="doCopy">&lt;script&gt;{{ code }}&lt;/script&gt;</ui-code>
			</div>
		</div>
		<template #footer>
			<div class="buttons">
				<ui-button design="link lg" @click="cancel">Cancelar</ui-button>
				<ui-button :disabled="!code" design="lg primary" @click="copyCode">Copiar Código</ui-button>
			</div>
		</template>
	</uiModal>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput } from '@/components/ui/form'
	import { uiModal } from '@/components/ui/modal'
	import { uiCode } from '@/components/ui'
	import { uiOverlayLoad } from '@/components/ui'

	import uiQueuesTable from '../queues-table'

	export default {
		components: {
			uiModal,
			uiButton,
			uiInput,
			uiCode,
			uiOverlayLoad,
			uiQueuesTable,
		},

		data() {
			return {
				code: '',
				title: '',
				loaderCode: false,
				doCopy: false,
			}
		},

		methods: {
			cancel() {
				this.$children[0].close()
			},

			copyCode() {
				this.doCopy = true
                
                setTimeout(() => {
                    this.doCopy = false
                }, 3000)
			},
		},

		watch: {
			code(value, oldValue) {
				if (value !== oldValue) {
					this.loaderCode = true
					setTimeout(() => {
						this.loaderCode = false
					}, 400)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
